import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import PopularSection from './components/PopularSection';
import RankingSection from './components/RankingSection';
import LatestSection from './components/LatestSection';
import ScrollToTop from '@/components/feature/ScrollToTop';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <main>
        <HeroSection />
        <CategorySection />
        <PopularSection />
        <RankingSection />
        <LatestSection />

        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
              免费下拉式阅读，畅享韩漫精彩
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed mb-8">
              韩漫网提供大量好看的韩国漫画大全，免费支持下拉式在线阅读，涵盖浪漫、剧情、悬疑等多种热门韩漫，随时轻松追更。
            </p>
            <div className="flex items-center justify-center gap-4 flex-wrap">
              <div className="flex items-center gap-2 px-5 py-2.5 rounded-lg bg-background-100">
                <i className="ri-smartphone-line text-primary-600 text-lg"></i>
                <span className="text-sm text-foreground-700 whitespace-nowrap">手机端适配</span>
              </div>
              <div className="flex items-center gap-2 px-5 py-2.5 rounded-lg bg-background-100">
                <i className="ri-download-line text-primary-600 text-lg"></i>
                <span className="text-sm text-foreground-700 whitespace-nowrap">下拉式阅读</span>
              </div>
              <div className="flex items-center gap-2 px-5 py-2.5 rounded-lg bg-background-100">
                <i className="ri-time-line text-primary-600 text-lg"></i>
                <span className="text-sm text-foreground-700 whitespace-nowrap">每日更新</span>
              </div>
              <div className="flex items-center gap-2 px-5 py-2.5 rounded-lg bg-background-100">
                <i className="ri-shield-check-line text-primary-600 text-lg"></i>
                <span className="text-sm text-foreground-700 whitespace-nowrap">完全免费</span>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}